import { getControlUnitById } from '.';
import { RootState } from '../../store.model';
import { createSelector } from 'reselect';

export const getControlUnitByIdGetterSelector = createSelector(
  [(state: RootState) => state],
  (state) => (props: { controlUnitId: string; deviceId: string }) =>
    getControlUnitById(state, props)
);
